import React, { useEffect, useState } from 'react';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import * as api from "core-module/services/api";
import Button from "common/components/CustomButtons/Button.jsx";
import { TextField } from "@material-ui/core";
import DialogContent from '@material-ui/core/DialogContent';
import { ApiError } from "core-module/services/error";

const UpdateDeviceAlias = props => {
  const [alias, setAlias] = useState(props.aliasName);

  function handleTextFieldChange(e) {
    setAlias(e.target.value);
  }

  function closeDialog() {
    setAlias(props.aliasName);
    props.closeDialog();
  }

  useEffect(() => {
    setAlias(props.aliasName);
  }, [props.aliasName]);

  async function postNewDeviceAlias() {
    console.log(alias);
    try {
      var res = await api.post(`user.${props.user}/wifidevicealias`, {
        mac: props.macAddress,
        alias: alias,
      });
    } catch (e) {
      if (e instanceof ApiError) {
        console.log(e.message);
        return false;
      } else {
        throw e;
      }
    }

    props.closeDialog();
    window.location.reload();
  }

  return (
    <Dialog justify="center"
    open={props.dialogOpen}>
    <DialogTitle style={{textAlign:"center"}}>Set Device Name<br></br>MAC: {props.macAddress}

    </DialogTitle>
    <DialogContent style={{textAlign:"center"}}>
      <TextField variant="filled" defaultValue={alias} onChange={handleTextFieldChange} />
      </DialogContent>
      <DialogActions style={{textAlign:"center"}}>
        <Button onClick={closeDialog} color="primary">
          Cancel
        </Button>
        <Button onClick={postNewDeviceAlias} color="primary">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UpdateDeviceAlias;